/* ============================================================
   roomedition
   ============================================================ */

export const roomedition = {
    id: "playlist_room_edition",
    type: "playlist",
    featured: true,
    title: "Room Edition",
    link: "room-edition",
    playlistBg: "#ffc182",
    imgUrl: "../image/listas/room-edition/noise-control.jpg",  //  /image/set/room-edition/room-edition.jpg
    hoverColor: "#ffc182",
    artist: "alibhtty",
    artistImgUrl: "../image/djs/alibhtty/alibhtty.jpg",
    artistBio: "https://instagram.com/ali.bhtty/",
    artistDownload: "Descargar",
    bannerUno: "",
    downloadData: [],
    playlistImages: [
      "../image/listas/room-edition/image1.jpg"
    ],
    playlistData: [
      {
        id: "1",
        songName: "NOISE CONTROL DnB (Live Set)",
        songimg: "../image/listas/room-edition/noise-control.jpg",
        songArtist: "Ali Bhtty",
        artistLink: "alibhtty",
        link: "https://dl.dropbox.com/scl/fi/z06q1ek561mm3tfpe53s8/NOISE-CONTROL-AliBhtty-Room-Edition.mp3?rlkey=abvpbmzpfvp84adjqz8crb6yt&dl=1",
        genre: "bass",
        trackTime: "20:43"
      }
    ]
  }
